import { Component, ElementRef, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { ListStoresParams, Store, StoresService } from 'src/app/core/stores.service';
import { ERROR_STORE_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-stores-data',
  templateUrl: './stores-data.component.html',
  styleUrls: ['./stores-data.component.scss'],
})
export class StoresDataComponent {
  @ViewChild('stores_load_more') load_more_layout?: ElementRef;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  is_list_running: boolean = true;
  is_load_more_running: boolean = true;
  stores?: Store[];
  cursor: string | null = null;
  total?: number;
  filters?: ListStoresParams;

  constructor(private stores_service: StoresService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.stores = [];
    this.cursor = null;
    this.filters = undefined;
    this.total = undefined;
    this.listStores();
  }

  onRefresh(): void {
    this.stores = [];
    this.cursor = null;
    this.filters = undefined;
    this.total = undefined;
    this.listStores();
  }

  onFilter(filters?: ListStoresParams): void {
    this.stores = [];
    this.cursor = null;
    this.filters = filters;
    this.total = undefined;
    this.listStores(filters);
  }

  onScrollEnd(): void {
    if (this.cursor && !this.is_load_more_running) this.onLoadMoreClick();
  }

  onLoadMoreClick(): void {
    this.listStores(this.filters, true);
  }

  listStores(filters?: ListStoresParams, is_load_more_running?: boolean): void {
    this.is_list_running = !is_load_more_running;
    this.is_load_more_running = is_load_more_running || false;

    const list_stores_params = {
      ...filters,
      cursor: this.cursor,
    };

    this.stores_service.listStores(list_stores_params).subscribe({
      next: response => {
        const stores = response.data.data;
        this.stores = (this.stores ? this.stores : []).concat(stores);
        this.cursor = response.data.cursor;
        if (list_stores_params.cursor == undefined) {
          this.total = response.data.total.value;
        }

        this.is_list_running = false;
        this.is_load_more_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code == ERROR_STORE_NOT_FOUND) {
          this.stores = [];
        } else {
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
        this.is_list_running = false;
        this.is_load_more_running = false;
      },
    });
  }
}
